import RewardedAds from "./container";

export default RewardedAds;